import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface FeatureHeroProps {
  title: string;
  subtitle: string;
  primaryCTA?: {
    text: string;
    link: string;
  };
  secondaryCTA?: {
    text: string;
    link: string;
  };
  gradientFrom?: string;
  gradientVia?: string;
  gradientTo?: string;
}

export function FeatureHero({
  title,
  subtitle,
  primaryCTA,
  secondaryCTA,
  gradientFrom = "from-primary/5",
  gradientVia = "via-grow/5",
  gradientTo = "to-secondary/5"
}: FeatureHeroProps) {
  return (
    <section className={`py-24 sm:py-32 bg-gradient-to-br ${gradientFrom} ${gradientVia} ${gradientTo}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        <p className="mt-6 text-lg leading-8 text-muted-foreground max-w-3xl mx-auto">
          {subtitle}
        </p>

        {(primaryCTA || secondaryCTA) && (
          <div className="mt-10 flex items-center justify-center gap-x-6">
            {primaryCTA && (
              <Button asChild size="lg" className="group">
                <Link to={primaryCTA.link}>
                  {primaryCTA.text}
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            )}
            {secondaryCTA && (
              <Button asChild variant="outline" size="lg">
                <Link to={secondaryCTA.link}>
                  {secondaryCTA.text}
                </Link>
              </Button>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
